import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import IrisPage from 'yoda-site-components/lib/components/IrisPage/IrisPage';
import ScrollTop from 'yoda-site-components/lib/components/ScrollTop/ScrollTop';
import { hotdealsPostProcessor } from 'yoda-interfaces/lib/IrisPage/IrisPage';
import irisComponentsForDept from 'yoda-site-components/lib/iris/components/forDepartment';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import { onPageReady } from '../../../actions/DepartmentAction';
import renderMiniPDP from '../../../helper/MiniPDPHelper';

export class DepartmentPage extends PureComponent {
    static defaultProps = {
        actions: {},
        irisData: {},
        params: {},
        location: {},
        isPreview: false,
    };

    static propTypes = {
        actions: PropTypes.objectOf(PropTypes.func),
        irisData: PropTypes.objectOf(
            PropTypes.oneOfType([
                PropTypes.object,
                PropTypes.string,
                PropTypes.number,
                PropTypes.bool,
            ])
        ),
        params: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string])),
        location: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string])),
        isPreview: PropTypes.bool,
    };

    componentDidMount() {
        const { analytics } = this.props.irisData;
        /* istanbul ignore if */
        if (analytics) {
            const { pageType, pageName } = analytics;
            this.props.actions.onPageReady(pageName, pageType);
        }
        LocalStorage.removeData('scrollToCartridge');
        LocalStorage.removeData('galleryScrollTo');
    }

    render() {
        const { department } = this.props.params;
        const patt = new RegExp('/d/'); // Regex to check the URL
        const { location } = this.props; // getting location from router
        let formattedUrl;

        if (this.props.isPreview) {
            formattedUrl = `${location.pathname}${location.search}`;
        } else if (patt.test(location.pathname)) {
            formattedUrl = `${location.pathname}`;
        } else {
            const ntype = this.props.params && this.props.params.ntype;
            formattedUrl = `/g/${department}/${ntype}?pageType=X2H2`;
        }

        const renderMiniPDPComponent = renderMiniPDP();
        return (
            <>
                <ScrollTop />
                <IrisPage
                    params={formattedUrl}
                    irisComponents={irisComponentsForDept}
                    pageType="DEPARTMENT"
                    aggregateAPI
                    data-automation-id="department"
                    postProcessor={hotdealsPostProcessor}
                />
                {renderMiniPDPComponent}
            </>
        );
    }
}

const mapStateToProps = ({ irisData, context }) => ({
    irisData,
    isPreview: context.isPreview || false,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            onPageReady,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentPage);
